import {useRouter} from "next/router";
import Checklist from "./common/Checklist";
import Sidebar from "./common/Sidebar";
import SidebarDropdownSelect from "./common/SidebarDropdownSelect";
import {handleChecklistFilterChange, handleDropdownSelect, handleSearchChange, replaceRouterQueryParamsShallow} from "../helpers/FilterFunctions";

import {useEffect, useState} from "react";
import {ArtDerUnterkunftItems, AusstattungItems, SchlafzimmerItems} from "../data/Filter/VermietungFilter.config";
import {Filter} from "../data/Filter/Filter.config";
import {useTranslation} from "next-i18next";
import {CustomTFunction, TranslationsKeys} from "../TranslationTypes";
import Checkbox from "./common/Checkbox";

export default function VermietungSidebar() {
	const router = useRouter();
	const {t} = useTranslation() as unknown as {
		t: CustomTFunction<TranslationsKeys>;
	};
	const [onlyLastMinutes, setOnlyLastMinutes] = useState(false);

	function handleFilterLastMinutes(isLastMinute: boolean) {
		if (isLastMinute) {
			replaceRouterQueryParamsShallow(router, {
				...router.query,
				lastminute: "1"
			});
		} else {
			const newQuery = router.query;
			delete newQuery.lastminute;
			replaceRouterQueryParamsShallow(router, newQuery);
		}
	}

	useEffect(() => {
		//console.log("router changed", router);
		if (router.isReady) {
			const isLastMinuteInQuery = router.query.lastminute === "1";
			//console.log("isLastMinuteInQuery", isLastMinuteInQuery);
			setOnlyLastMinutes(isLastMinuteInQuery);
			//handleFilterLastMinutes(isLastMinuteInQuery);
		}
	}, [router.isReady, router.query.lastminute]);

	return (
		<Sidebar
			onSearchChange={(v) => handleSearchChange(v, router)}
			resetFilters={() => {
				const {from_date, to_date, min_persons_total, id} = router.query;
				const cities = router.query[Filter.City.queryKey];
				const queryParams = {
					from_date,
					to_date,
					min_persons_total,
					id,
					[Filter.City.queryKey]: cities
				};
				Object.keys(queryParams).forEach((key) =>
					queryParams[key] === undefined ? delete queryParams[key] : {}
				);
				replaceRouterQueryParamsShallow(router, queryParams);
			}}
		>
			<Checkbox
				item={{
					id: "Last Minute",
					primaryLabel: "Last Minute",
					checked: onlyLastMinutes ?? undefined
				}}
				onChange={() => {
					const currLastMinutes = onlyLastMinutes;
					handleFilterLastMinutes(!currLastMinutes);
					//setOnlyLastMinutes(!currLastMinutes);
				}}
			/>
			<SidebarDropdownSelect
				dropDowns={[SchlafzimmerItems(router)]}
				onSelectItems={(key, items) => {
					console.log(key, items, "desk"),
						handleDropdownSelect(key, items, router, t);
				}}
			/>
			<Checklist
				title={ArtDerUnterkunftItems(router).label}
				items={ArtDerUnterkunftItems(router).items}
				onChange={(item, checked) =>
					handleChecklistFilterChange(item, checked, router)
				}
			/>
			<Checklist
				title={AusstattungItems(router).label}
				items={AusstattungItems(router).items}
				onChange={(item, checked) =>
					handleChecklistFilterChange(item, checked, router)
				}
			/>
			{/* <SidebarDropdownSelect
        dropDowns={[DistanceToItems(router, Filter.DistanceToSea)]}
        onSelectItems={(key, items) =>
          handleDropdownSelect(key, items, router, t)
        }
      />
      <SidebarDropdownSelect
        dropDowns={[
          DistanceToItems(router, Filter.DistanceToCenter),
          DistanceToItems(router, Filter.DistanceToGolf)
        ]}
        onSelectItems={(key, items) =>
          handleDropdownSelect(key, items, router, t)
        }
      /> */}
		</Sidebar>
	);
}
